import { render, staticRenderFns } from "./AvatarCourse.vue?vue&type=template&id=ccaf2660&scoped=true&"
import script from "./AvatarCourse.vue?vue&type=script&setup=true&lang=js&"
export * from "./AvatarCourse.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccaf2660",
  null
  
)

export default component.exports